import { pageRoutes } from "./pageRoutes";

// domain :
export const BASE_URL = "https://robotcombat101.com/admin/api/";
// export const BASE_URL = "http://192.168.1.36:8000/api/";

// export const getBaseUrl = () => {
//   console.log({hostname:window.location.hostname})
//   return window.location.hostname === "robotcombat101.com"
//     ? "https://robotcombat101.com/admin/api/"
//     : "http://192.168.29.76:8000/api/";
// };

// export const BASE_URL = getBaseUrl();

// Home :
export const contactUsAPI = "contact-us";
export const servicesAPI = "get-all-service";
export const homeSectionAPI = "get-home-section";
export const servicesDetailByIdAPI = "get-service-details";
export const weightClassResrictioAPI = "get-all-weight-class-restriction";

// League :
export const leagueAPI = "get-league-page";
export const sparcRuleAPI = "get-all-league-rules";
export const leagueTournamentsAPI = "get-all-tournament";
export const leaguepresentationsAPI = "get-all-presentation";

// More :
export const fetchPartnerAPI = "get-all-partner";
export const fetchAboutAPI = "get-about-section";
export const toolsTradeAPI = "get-all-tools-trade";
export const privacyPolicyAPI = "get-privacy-policy";
export const fetchTeamLeadersAPI = "get-all-members";
export const eventCoverageAPI = "get-all-event-coverage";
export const glossaryTermsAPI = "get-terms-and-conditions";
export const saveVisitorEmailAPI = "save-visitor-email";

// Auth :
export const memberLoginAPI = "member-login";
export const memberRegisterAPI = "member-register";

export const loginAPI = "login";
export const signupAPI = "register";

export const getMyAddressAPI = "get-my-addresses";
export const forgotPasswordAPI = "forgot-password";
export const changePasswordAPI = "change-password";
export const deleteAddressAPI = "remove-billing-address";

// Profile :
export const profileAPI = "get-my-profile";
export const profileUpdateAPI = "update-profile";

// Orders :
export const productsAPI = "products";
export const addToCartAPI = "add-to-cart";
export const updateCartAPI = "update-cart";
export const productDetailAPI = "products";
export const placeOrderAPI = "place-order";
export const fetchOrdersAPI = "get-my-orders";
export const completeOrderAPI = "complete-order";
export const deleteProductAPI = "remove-from-cart";
export const getCartDetailsAPI = "get-cart-details";
export const relatedProductAPI = "get-related-products";
export const sendProductFeedbackAPI = "send-product-review";

// Lessons :
export const lessonElectricalEngineerAPI =
  "get-all-lesson-electrical-engineering";
export const lessonPCBsAPI = "get-all-lesson-pcbs";
export const lessonFusionAPI = "get-all-lesson-fusion";
export const lessonSlicingAPI = "get-all-lesson-slicing";
export const lessonESCsBESCEsAPI = "get-all-lesson-bescs";
export const lessonBettriesAPI = "get-all-lesson-batteries";
export const lessonReceiversAPI = "get-all-lesson-receivers";
export const lessonSolderingAPI = "get-all-lesson-soldering";
export const lessonThinkercadAPI = "get-all-lesson-thinkercad";
export const lesson3dPrintingAPI = "get-all-lesson-3d-printing";
export const lessonGearRatiosAPI = "get-all-lesson-gear-ratios";
export const lesson3dModelingAPI = "get-all-lesson-3d-modeling";
export const lessonWeaponPhysicsAPI = "get-all-lesson-weapon-physics";
export const lessonPhysicsgeometryAPI = "get-all-lesson-physics-geometry";
export const lessonMaterialscienceAPI = "get-all-lesson-material-science";
export const lessonBrushedBrushlessAPI = "get-all-lesson-brushed-brushless";

// Weight Class-Specific Info. and tips\
export const weightAntweightAPI = "get-all-weight-antweight";
export const weightSportsmanAPI = "get-all-weight-sportsman";
export const weightFairyweightAPI = "get-all-weight-fairyweight";
export const weightHobbyweightAPI = "get-all-weight-hobbyweight";
export const weightBeetleweightAPI = "get-all-weight-beetleweight";
export const weightFeatherweightAPI = "get-all-weight-featherweight";
export const weightPlasticAntweightAPI = "get-all-weight-plastic-antweight";

// Google Classrooms

export const googleLogin = "auth/google/login/";
export const authLoginCallbackAPI = "auth/google/callback/";

export const courseListAPI = "google-classroom/courses";
export const courseAssignmentListAPI = "google-classroom/assignments/";
export const acceptInvitaionAPI = "google-classroom/accept-invitation";
export const deleteInvitaionAPI = "google-classroom/delete-invitation";
export const fetchClassesInvitationsListAPI = "google-classroom/invitations";

export const updateMemberDetailAPI = "update-member-detail";

// Bot Directory

export const botTypesAPI = "get-all-bot-types";
export const fetchBotDirectoriesAPI = "get-all-bots";
export const getWeightClassesCategoriesAPI = "get-all-weight-class-categories";

export const createBotAPI = "create-bot";
export const updateBotAPI = "update-bot";
export const getAllEmbedsAPI = "get-all-embeds";


// member
export const memberDetailAPI = "get-member-details";

export const deleteBotAPI = "delete-bot";
export const delteTeamAPI = "delete-member";

export const getAllMediaAPI = "get-all-media";

// Curriculum :
export const getSubscriptionsAPI = "get-all-subscription"
export const getCurriculumOverview = "get-curriculum-overview"

export const arr = [
  {
    path: "battlebots",
    label: "Battlebots",
    url: "get-all-battle-bots",
  },
  {
    path: "controlbots",
    label: "Control Bots",
    url: "get-all-control-bots",
  },
  {
    path: "drumspinners",
    label: "Drum Spinners",
    url: "get-all-drum-spinners",
  },
  {
    path: "firebots",
    label: "Firebots",
    url: "get-all-firebots",
  },
  {
    path: "fliper-bots",
    label: "Flipper bots",
    url: "get-all-flipper-bots",
  },
  {
    path: "gearboxes",
    label: "Gearboxes",
    url: "get-all-gearboxes",
  },
  {
    path: "hammerbots",
    label: "Hammerbots",
    url: "get-all-hammerbots",
  },
  {
    path: "handTools",
    label: "Hand Tools",
    url: "get-all-hand-tools",
  },
  {
    path: "horizontal-spinners",
    label: "Horizontal spinners",
    url: "get-all-horizontal-spinners",
  },
  {
    path: "modes-of-transferring-motion",
    label: "Modes of transferring motion",
    url: "get-all-modes-of-transferring-motion",
  },
  {
    path: "nhrl",
    label: "NHRL",
    url: "get-all-nhrl",
  },
  {
    path: "overheadSaws",
    label: "Overhead Saws",
    url: "get-all-overhead-saws",
  },
  {
    path: "plants",
    label: "Plants",
    url: "get-all-plants",
  },
  {
    path: "power-tools",
    label: "Power Tools",
    url: "get-all-power-tools",
  },
  {
    path: "printed-circuit-boards",
    label: "Printed Circuit Board (Malenki)",
    url: "get-all-printed-circuit-boards",
  },
  {
    path: "rcl",
    label: "RCL",
    url: "get-all-rcl",
  },
  {
    path: "ssp",
    label: "SSP",
    url: "get-all-ssp",
  },
  {
    path: "turnabots",
    label: "Turnabot",
    url: "get-all-turnabots",
  },
  {
    path: "types-of-drive-system",
    label: "Types of drive systems",
    url: "get-all-types-of-drive-systems",
  },
  {
    path: "vertical-spinners",
    label: "Vertical spinners",
    url: "get-all-vertical-spinners",
  },
  {
    path: "drive-systems",
    label: "Drive Systems",
    url: "get-all-drive-systems",
  },
  {
    path: "weapons-systems",
    label: "Weapons systems",
    url: "get-all-weapons-systems",
  },
];
export const getUrl = (route) => {
  const item = arr.find(({ path }) => path === route);
  return item ? item.url : "";
};
